import { ValidationModel, ValidationType } from "@/services/validation/types";

export function customExtensionValidators(currentEntityId: string = "") {
    return {
        name: {
            rules: [
                { type: ValidationType.Required },
                { type: ValidationType.Min, value: 1 },
                { type: ValidationType.UniqueExtensionName, entityId: currentEntityId }
            ]
        } as ValidationModel,
        menuText: {
            rules: [
                { type: ValidationType.Required },
                { type: ValidationType.Min, value: 1 }
            ]
        } as ValidationModel,
        menuIconFileId: {
            rules: [
                { type: ValidationType.Required },
                { type: ValidationType.Min, value: 1 }
            ]
        } as ValidationModel
    };
}
